<template>
  <div class="mt-3">
    <div class="header-purple">
      <div>
        <p class="mb-0">
          <strong>รายละเอียดคำสั่งซื้อ</strong>
        </p>
      </div>
    </div>
    <div class="bg-white">
      <b-container class="p-0">
        <b-table
          responsive
          :thead-tr-class="thTableProduct"
          :tbody-tr-class="trTableProduct"
          class="text-center"
          :fields="fields"
          :items="orderProductDetail"
          :busy="isBusy"
          show-empty
          empty-text="ไม่พบข้อมูล"
        >
          <template v-slot:head(imageUrl)="">
            <div class="border-right">
              <strong>ภาพสินค้า</strong>
            </div> </template
          ><template v-slot:head(sku)="">
            <div class="border-right">
              <strong>SKU</strong>
            </div> </template
          ><template v-slot:head(productName)="">
            <div class="border-right">
              <strong>ชื่อสินค้า</strong>
            </div> </template
          ><template v-slot:head(countProduct)="">
            <div class="border-right">
              <strong>จำนวนชิ้น</strong>
            </div> </template
          ><template v-slot:head(pricePerItem)="">
            <div class="border-right">
              <strong>ราคาต่อหน่วย</strong>
            </div>
          </template>
          <template v-slot:cell(imageUrl)="data">
            <div>
              <div
                v-if="data.item.imageUrl"
                class="table-image"
                v-bind:style="{
                  'background-image': 'url(https://tnl-warehouse-api-dev.dosetech.co' + data.item.imageUrl + ')',
                }"
              ></div>
              <div v-else>
                -
              </div>
            </div>
          </template>
          <template v-slot:cell(sku)="data">
            <div v-if="data.item.sku" class="text-table">
              <p class="m-0">{{ data.item.sku }}</p>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(productName)="data">
            <div v-if="data.item.productName" class="text-left text-table">
              <p class="m-0">{{ data.item.productName }}</p>
              <span v-if="data.item.promotion">
                <b-badge pill variant="Info" class="px-3 py-2 GWP mt-1">{{
                  data.item.promotion
                }}</b-badge
                ><br />
              </span>
              <span class="text-danger" v-if="data.item.isFree == 1"
                >(ฟรี)</span
              >
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(countProduct)="data">
            <div class="stock-text" v-if="data.item.countProduct">
              <p class="m-0">{{ data.item.countProduct | numeral("0,0") }}</p>
            </div>
            <div v-else class="stock-text"><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(pricePerItem)="data">
            <p class="m-0 price-text" v-if="data.item.pricePerItem">
              ฿ {{ data.item.pricePerItem | numeral("0,0.00") }}
            </p>
            <p v-else class="m-0 price-text">-</p>
          </template>
          <template v-slot:cell(total)="data">
            <p
              class="m-0 price-text"
              v-if="data.item.pricePerItem != 0 && data.item.countProduct != 0"
            >
              ฿
              {{ (data.item.pricePerItem * data.item.countProduct) | numeral("0,0.00") }}
            </p>
            <p v-else class="m-0 price-text">-</p>
          </template>
        </b-table>
        <div class="p-4">
          <b-row>
            <b-col sm="7">
            </b-col>
            <b-col sm="5" class="d-flex justify-content-end">
              <div class="bg-gray">
                <b-row class="pt-2 pl-3 pr-3 pb-2">
                  <b-col>
                    <b>รายได้รวม</b>
                  </b-col>
                  <b-col class="d-flex justify-content-end">
                    <b
                      >฿
                      {{
                        orderProductPriceDetail.subTotal | numeral("0,0.00")
                      }}</b
                    >
                  </b-col>
                </b-row>
                <b-row class="pt-0 pl-3 pr-3 pb-2">
                  <b-col>
                    <b>ราคาสินค้า</b>
                  </b-col>
                  <b-col class="d-flex justify-content-end">
                    <b
                      >฿
                      {{
                        orderProductPriceDetail.subTotal | numeral("0,0.00")
                      }}</b
                    >
                  </b-col>
                </b-row>
                <b-row class="pt-0 pl-3 pr-3 pb-2">
                  <b-col sm="6">
                    <b
                      >ค่าจัดส่ง
                      <b-button
                        v-if="collapseShipping"
                        variant="link"
                        size="sm"
                        class="btn-collapse mb-1"
                        @click="collapseShipping = false"
                      >
                        <b-icon icon="chevron-down"></b-icon>
                      </b-button>
                      <b-button
                        v-if="!collapseShipping"
                        variant="link"
                        size="sm"
                        class="btn-collapse  mb-1"
                        @click="collapseShipping = true"
                      >
                        <b-icon icon="chevron-up"></b-icon>
                      </b-button>
                    </b>
                  </b-col>
                  <b-col sm="6" class="d-flex justify-content-end">
                    <b
                      >฿
                      {{
                        orderProductPriceDetail.shippingCost - orderProductPriceDetail.shippingDiscount
                          | numeral("0,0.00")
                      }}
                    </b>
                  </b-col>
                  <b-col>
                    <b-collapse
                      v-model="collapseShipping"
                      class="collapse-shipping"
                    >
                      <b-row class="pl-3">
                        <b-col sm="6">
                          <b class="text-gray">ค่าจัดส่ง</b>
                        </b-col>
                        <b-col sm="6" class="d-flex justify-content-end">
                          <b class="text-gray"
                            >฿
                            {{
                              orderProductPriceDetail.shippingCost
                                | numeral("0,0.00")
                            }}</b
                          >
                        </b-col>
                        <b-col sm="6">
                          <b class="text-gray">ส่วนลดค่าจัดส่ง</b>
                        </b-col>
                        <b-col sm="6" class="d-flex justify-content-end">
                          <b class="text-gray"
                            >฿
                            {{
                              orderProductPriceDetail.shippingDiscount
                                | numeral("0,0.00")
                            }}</b
                          >
                        </b-col>
                      </b-row>
                    </b-collapse>
                  </b-col>
                </b-row>
                <b-row class="pt-0 pl-3 pr-3 pb-2">
                  <b-col sm="6">
                    <b
                      >ส่วนลด
                      <b-button
                        v-if="collapseDiscount"
                        variant="link"
                        size="sm"
                        class="btn-collapse mb-1"
                        @click="collapseDiscount = false"
                      >
                        <b-icon icon="chevron-down"></b-icon>
                      </b-button>
                      <b-button
                        v-if="!collapseDiscount"
                        variant="link"
                        size="sm"
                        class="btn-collapse  mb-1"
                        @click="collapseDiscount = true"
                      >
                        <b-icon icon="chevron-up"></b-icon>
                      </b-button>
                    </b>
                  </b-col>
                  <b-col sm="6" class="d-flex justify-content-end text-purple">
                    <b
                      >- ฿
                      {{ orderProductPriceDetail.discount | numeral("0,0.00") }}
                    </b>
                  </b-col>
                  <b-col>
                    <b-collapse
                      v-model="collapseDiscount"
                      class="collapse-shipping"
                    >
                      <b-row class="pl-3">
                        <b-col sm="6">
                          <b class="text-gray">ส่วนลดจากร้านค้า</b>
                        </b-col>
                        <b-col sm="6" class="d-flex justify-content-end">
                          <b class="text-gray"
                            >- ฿
                            {{
                              orderProductPriceDetail.storeDiscount
                                | numeral("0,0.00")
                            }}</b
                          >
                        </b-col>
                        <b-col sm="7">
                          <b class="text-gray">ส่วนลดจากแพลตฟอร์ม</b>
                        </b-col>
                        <b-col sm="5" class="d-flex justify-content-end">
                          <b class="text-gray"
                            >- ฿
                            {{
                              orderProductPriceDetail.platformDiscount
                                | numeral("0,0.00")
                            }}</b
                          >
                        </b-col>
                        <b-col sm="7">
                          <b class="text-gray">ส่วนลดค่าจัดส่ง</b>
                        </b-col>
                        <b-col sm="5" class="d-flex justify-content-end">
                          <b class="text-gray"
                            >- ฿
                            {{
                              orderProductPriceDetail.shippingDiscount
                                | numeral("0,0.00")
                            }}</b
                          >
                        </b-col>
                      </b-row>
                    </b-collapse>
                  </b-col>
                </b-row>
                <div class="bg-purple pt-3 pb-3 pl-3 pr-3">
                  <b-row>
                    <b-col>
                      <b>ยอดสุทธิ</b>
                    </b-col>
                    <b-col class="d-flex justify-content-end">
                      <b
                        >฿
                        {{
                          orderProductPriceDetail.grandTotal | numeral("0,0.00")
                        }}</b
                      >
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import { BIcon } from "bootstrap-vue";
// import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
export default {
  name: "OrderDetailPanel",
  components: { BIcon },
  props: {
    orderProductDetail: {
      type: Array,
      isRequired: true,
    },
    orderProductPriceDetail: {
      type: Object,
      isRequired: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: "imageUrl",
          label: `ภาพสินค้า`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "15%",
          },
          hold: false,
        },
        {
          key: "sku",
          label: `SKU`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "20%",
          },
          hold: false,
        },
        {
          key: "productName",
          label: `ชื่อสินค้า`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "30%",
          },
          hold: false,
        },
        {
          key: "countProduct",
          label: `จำนวนชิ้น`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "10%",
          },
          hold: false,
        },
        {
          key: "pricePerItem",
          label: `ราคาต่อหน่วย`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "10%",
          },
          hold: false,
        },
        {
          key: "total",
          label: `ราคาสุทธิ`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "15  %",
          },
          hold: false,
        },
      ],
      thTableProduct: {
        "border-bottom": "2px solid #f8f8f8 !important",
        "min-height": "80px !important",
      },
      trTableProduct: { "border-bottom": "2px solid #f8f8f8 !important" },
      isBusy: false,
      collapseShipping: true,
      collapseDiscount: true,
      collapseService: true,
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.header-purple {
  padding: 1rem 1.5rem;
  background: #e0e1f4;
}
.price-text {
  white-space: nowrap;
}
.text-table {
  color: #7e7e7e;
}
.bg-gray {
  color: #333333;
  background-color: #f1f1f1;
  width: 85%;
}
.bg-purple {
  color: #ffffff;
  background-color: #8a44c3;
}
.btn-collapse {
  color: #333333;
}
.text-gray {
  color: #c5c5c5;
}
.text-purple {
  color: #8a44c3;
}
.collapse-shipping {
  margin-top: -5px;
}
.summarize {
  margin-right: -80px;
  width: 60%;
}
.stock-text {
  min-width: 80px;
}
.GWP {
  background-color: #e3e2f2;
  color: #8078c6;
}
.order-btn-link {
  color: #8f20c6;
  font-size: 16px;
  cursor: pointer;
  text-decoration: underline;
}
</style>
